/**
 * Représentation visuelle du statut d'une demande, partagée par la table, le
 * kanban et la fiche. Une seule définition des couleurs : un « Gagné » vert
 * dans la table et gris dans le kanban serait lu comme deux états différents.
 */
import Chip from "@mui/material/Chip";
import { LIBELLES_STATUT_LEAD, type StatutLead, libelle } from "./LeadsDonnees";

type CouleurChip = "default" | "info" | "warning" | "success" | "error";

/**
 * Les couleurs suivent l'avancement, pas l'humeur : le neutre pour ce qui
 * n'a pas encore bougé, le vert pour l'affaire gagnée, le rouge pour l'affaire
 * perdue. Le libellé reste affiché en toutes lettres — la couleur seule ne
 * transmet rien à qui ne la distingue pas.
 */
export const COULEURS_STATUT: Record<StatutLead, CouleurChip> = {
  nouveau: "info",
  contacte: "warning",
  visite: "default",
  gagne: "success",
  perdu: "error",
};

/** Teintes de fond des colonnes du kanban, assez pâles pour rester lisibles. */
export const FONDS_STATUT: Record<StatutLead, string> = {
  nouveau: "#E8F1FB",
  contacte: "#FDF3E2",
  visite: "#F0F1F4",
  gagne: "#E9F6EC",
  perdu: "#FBECEC",
};

export function PuceStatut({
  statut,
  taille = "small",
}: { statut: string; taille?: "small" | "medium" }) {
  const couleur = COULEURS_STATUT[statut as StatutLead] ?? "default";
  return (
    <Chip
      size={taille}
      color={couleur}
      variant={couleur === "default" ? "outlined" : "filled"}
      label={libelle(LIBELLES_STATUT_LEAD, statut)}
    />
  );
}
